
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/editor",
      function () {
        return require("private-next-pages/editor.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/editor"])
      });
    }
  